export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $('.life_choice_slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,

      responsive: [

        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
          },
        },
        {
          breakpoint: 568,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          },
        },
      ],
    });

    // $('.std_slider').slick({
    //   infinite: true,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   arrows: false,
    //   dots: true,
    // });

    $('.mob_services_slider').slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: true,

      responsive: [
        {
          breakpoint: 568,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          },
        },
      ],
    });



    // vertical accordion 
    const horizontalAccordions = $('.accordion.width');

    horizontalAccordions.each((index, element) => {
      const accordion = $(element);
      const collapse = accordion.find('.collapse');
      const bodies = collapse.find('> *');
      // accordion.height(accordion.height());
      bodies.width(bodies.eq(0).width());
      collapse.not('.show').each((index, element) => {
        $(element).parent().find('[data-toggle=collapse]').addClass('collapsed');
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js